
// FIXME Inline this component
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Checkout extends Vue {}
